import React from 'react';
import HTML from '@builder.io/react-native-render-html';
import {
  JsonFormsRendererRegistryEntry,
  LabelProps,
  rankWith,
  uiTypeIs,
  and,
  optionIs,
  Tester,
} from '@jsonforms/core';
import { withJsonFormsLabelProps } from '@jsonforms/react';
import Colors from '../../../../constants/Colors';
import { RENDERER_RANK_PREFERRED_MATCH } from '../constants';

export const testContainsHtml: Tester = optionIs('containsHTML', true);

const baseStyle = { color: Colors.veryDarkGray };
const defaultTextProps = { allowFontScaling: false };

export const RichTextRenderer: JsonFormsRendererRegistryEntry = {
  tester: rankWith(RENDERER_RANK_PREFERRED_MATCH, and(uiTypeIs('Label'), testContainsHtml)),
  renderer: withJsonFormsLabelProps((props: LabelProps) => {
    return (
      <HTML source={{ html: props.text ?? '' }} baseStyle={baseStyle} defaultTextProps={defaultTextProps} />
    );
  }),
};
